// extracted by mini-css-extract-plugin
export var introImage = "page-module--intro-image--5Ya-x";